export const APP_NAME = 'simat'

export const API_BASE = (import.meta.env.VITE_API_BASE ?? '').replace(/\/+$/, '')
